module.exports = __webpack_public_path__ + "img/2b)Hotel Weitzer -Graz)Die gesamten Gästezimmer wurden von GERA Montagen neu ausgestattet.jpg";